export function modals() {
  const popupButtons = document.querySelectorAll('[data-popup-open]');
  const closeButtons = document.querySelectorAll('[data-popup-close]');
  const bodyElement = document.body;

  popupButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      openPopup(this);
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      closePopup(event);
    });
  });

  function openPopup(self) {
    const popupVariant = self.getAttribute('data-popup-open');
    const popupEl = document.querySelector(`.popup--${[popupVariant]}`);

    if (popupEl) {
      popupEl.classList.add('open-popup');
      bodyElement.classList.add('overflow');
    }
  }

  function closePopup({
    target
  }) {
    const parentElement = target.closest('.popup');

    if (parentElement) {
      parentElement.classList.remove('open-popup');
      bodyElement.classList.remove('overflow');
    }
  }
}


// WEBPACK FOOTER //
// app/scripts/components/modals.js